import type { McpToolDefinition } from "@lumen/shared";

export function mcpActionGroup(name: string) {
  const parts = name.split(/[_.:/-]/);
  return parts.length > 1 ? parts[0].toLowerCase() : "";
}

export function filterMcpActions(
  tools: McpToolDefinition[],
  query: string,
  group: string,
  selectedOnly: boolean,
  selected: Set<string>,
) {
  const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return tools.filter((tool) => {
    const text =
      `${tool.name} ${tool.title ?? ""} ${tool.description}`.toLowerCase();
    return (
      (!group || mcpActionGroup(tool.name) === group) &&
      (!selectedOnly || selected.has(tool.name)) &&
      terms.every((term) => text.includes(term))
    );
  });
}

/** Apply a selection to a subset without changing hidden or other-server selections. */
export function setMcpActionSelection(
  current: string[],
  names: string[],
  checked: boolean,
) {
  const next = new Set(current);
  for (const name of names) {
    if (checked) next.add(name);
    else next.delete(name);
  }
  return [...next];
}
